<template xmlns:v-touch="http://www.w3.org/1999/xhtml">
    <transition name="slide">
        <div class="dock-pull">
            <div class="dock-pull-inner">
                <div id="menu_draggable" v-touch:moved.stop="movedHandler"
                     v-touch:moving.stop="swipeMenuHandler"
                     v-touch:swipe.stop="endHandler">
                    <div class="dock-pull-dragbar">
                        <div class="pd-inner"></div>
                    </div>
                    <div class="dock-pull-header">
                        <div v-if="showBackButton" class="dock-pull-header-back">
                            <a @click="$router.go(-1)"><i class="far fa-arrow-left"></i></a>
                        </div>
                        <div class="dock-pull-header-controls">
                            <h2>{{ $route.meta.alias ? $route.meta.alias : $route.name }}</h2>
                            <router-link class="dock-pull-close" tag="a" to="/" @click.native="setDock(false)">
                            <span class="fa-stack fa-xs">
                                <i class="fa fa-circle fa-stack-2x icon-background"></i>
                                <i class="fa fa-times fa-stack-1x"></i>
                            </span>
                            </router-link>
                        </div>
                    </div>
                </div>
                <div class="dock-pull-body" @wheel.passive.stop="bodyScroll" v-touch:swipe.passive.stop="swipeBodyHandler">
                    <router-view ></router-view>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
// todo refs for a dock-pull, make vuex on use
import { mapMutations } from 'vuex'
export default {
  name: 'Menu',
  props: ['alias'],
  data () {
    return {
      tDelta: 0,
      startY: 0,
      initY: 0,
      showBackButton: false
    }
  },
  methods: {
    ...mapMutations({
      setDock: 'dockVisibility'
    }),
    bodyScroll (el, binding) {
      this.setDock(el.deltaY > 0)
    },
    swipeBodyHandler (dir) {
      console.log(this.tDelta)
      switch (dir) {
        case 'top': this.setDock(true); break
        case 'bottom': this.setDock(false); break
      }
      this.endHandler()
    },
    swipeMenuHandler (event) {
      const dy = event.touches[0].clientY - this.initY
      this.tDelta = this.startY + dy
      if (this.tDelta >= 0) {
        this.$el.style.top = this.tDelta + 'px'
      }
      console.log('Moving: ' + this.tDelta)
      return false
    },
    movedHandler (event) {
      this.startY = this.$parent.$el.parentElement.offsetTop
      this.initY = event.touches[0].clientY
      console.log('Starting')
      return false
    },
    endHandler (event) {
      if (this.tDelta < 40) {
        this.$el.style.top = ''
      } else {
        this.setDock(false)
        this.$router.push({path: '/'})
      }
      console.log('Ending')
    },
    test (event) {
      console.log(event)
    }
  },

  watch: {
    '$route' (to, from) {
      const toDepth = to.path.split('/').length
      const fromDepth = from.path.split('/').length
      this.showBackButton = toDepth > fromDepth || Object.keys(to.query || from.query).length !== 0
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/controls/Menu.vue